// extracted by mini-css-extract-plugin
module.exports = {"container":"content_text_highlighted-module--container--2lhU-"};